import React, { Component } from 'react';
import styled from 'styled-components';
import { media, Flex } from 'lib/style-utils';

const Wrapper = styled.div`
  width: 100%;
`;

const Notice = Flex.extend`
  flex-direction: column;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 200px;
  padding: 15px;
  border: 1px solid #757575;
  background: #ffffff;
  font-famile: 'Noto Sans KR';
  font-size: 16px;
  color: #444444;
  border-radius: 15px;
  z-index: 50;
`;

const Message = styled.p`
  width: 275px;
  word-break: keep-all;
  line-height: 1.6;
  text-align: center;
`;

const Btn = styled.button`
  width: 160px;
  height: 45px;
  padding: 0px 25px;
  background: #fff;
  color: #37b24d;
  border: 1px solid #eeeeee;
  border-radius: 25px;
  font-family: Lato;
  margin: 30px auto 0;
  font-size: 14px;
  letter-spacing: 0.7px;
  cursor: pointer;

  &:hover {
    background: #f9f9f9;
  }

  &:active {
    background: #f2f2f2;
  }

  ${media.mobile`
    width: 154px;
    margin-top: 30px;
    font-size: 13px;
  `}
`;

const Dimmed = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 45;
`;

class Modal extends Component {

  componentDidMount() {
    const body = (document.documentElement && document.documentElement.style) || document.body.style;
    body.overflowY = 'hidden';
  }

  handleModal = () => {
    const { FormActions } = this.props;
    const body = (document.documentElement && document.documentElement.style) || document.body.style;

    FormActions.hiddenNotice();
    body.overflowY = 'auto';
  }

  render() {
    const { alertMessage } = this.props;

    return (
      <Wrapper>
        <Notice>
          <Message>{alertMessage}</Message>
          <Btn onClick={this.handleModal}>확인</Btn>
        </Notice>
        <Dimmed/>
      </Wrapper>
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Contact/Modal.js